export const contactFileStates = {
  contactFiles: [],
  contactFilesSearchResult: [],
  contactFilesStart: 0,
};
